exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2LVCrxyw7FDJqe5P4L08RV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2LVCrxyw7FDJqe5P4L08RV{padding:0 8px}", ""]);
// Exports
exports.locals = {
	"container": "_2LVCrxyw7FDJqe5P4L08RV"
};